const env = {
  // SERVER: 'http://localhost:8082',
  SERVER: 'https://api.stayloyal.net',
  // API_URL: 'http://localhost:8082/api',
  // API_URL : "http://192.168.0.44:8082/api"
  API_URL: 'https://api.stayloyal.net/api',
}

export default env
